import React from "react";

export const ExpenseInfo = () => {
  return (
    <div>
      <h2>Expense Info</h2>
    </div>
  );
};

export default ExpenseInfo;
